// extracted by mini-css-extract-plugin
export default {"container":"SuspenseBoundary_container__4TXOP"};